// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_payment-link-details_btn-primary__U_PRI","buttonContainer":"_payment-link-details_buttonContainer__2adUr","topButtons":"_payment-link-details_topButtons__1rsNM"};